module.exports = __webpack_public_path__ + "media/images/logo/Logo2-99923927ee4b08af812ba85c86a777c1.png";